import { render, staticRenderFns } from "./ConfirmPrior.vue?vue&type=template&id=12be7979&scoped=true&"
import script from "./ConfirmPrior.vue?vue&type=script&lang=js&"
export * from "./ConfirmPrior.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPrior.vue?vue&type=style&index=0&id=12be7979&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be7979",
  null
  
)

export default component.exports